import React, { FC, ReactElement } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormProfilePictureModel } from '../../../../../shared/kiosk';
import { CheckboxLabel } from '../../../../components/CheckboxLabel';
import { useTranslation } from '../../../../translations';
import {
  AbstractElementEditor,
  UpdateFormProps,
  UpdateFormPropsNoTrans,
} from './AbstractElementEditor';

export class ProfilePictureEditor extends AbstractElementEditor<FormProfilePictureModel> {
  public getDescription(): string {
    return 'Allow users to update their profile picture';
  }

  public getName(): string {
    return 'Profile picture';
  }

  public getIcon(): string {
    return 'image';
  }

  public override getUpdateForm({
    node,
    update,
  }: UpdateFormProps<FormProfilePictureModel>): ReactElement {
    return <ProfilePictureDetails node={node} update={update} />;
  }
}

// eslint-disable-next-line @typescript-eslint/no-deprecated
const ProfilePictureDetails: FC<UpdateFormPropsNoTrans<FormProfilePictureModel>> = ({
  update,
  node,
}) => {
  const { ts } = useTranslation();

  return (
    <div>
      <FormGroup>
        <Label for="title">{ts('title')}</Label>
        <Input
          id="title"
          name="title"
          onChange={(e) => {
            update({ ...node, title: e.target.value });
          }}
          value={node.title ?? ''}
        />
      </FormGroup>
      <CheckboxLabel
        checked={node.ignoreGravatar}
        id="ignoreGravatar"
        onChange={(e) => {
          update({ ...node, ignoreGravatar: e.target.checked });
        }}
      >
        {ts('ignore_gravatar_default_image')}
      </CheckboxLabel>
    </div>
  );
};
